/**
 * リクエスト
 */
export class ContractNoticeRequest {
	public planCode				: string = null; // プランコード
	public companyProductCode	: string = null; // 保険商品コード
	public agentCode			: string = null; // 代理店コード
}